import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ArrowIconComponent } from '../arrow-icon/arrow-icon.component';
import { ValueType } from '../overview-tiles/types';

interface TrendData {
  value: string | number;
  status: ValueType;
  statusColor?: 'gray' | 'yellow';
  direction: 'up' | 'down' | undefined;
  size: 'small' | 'big';
  display: string;
}

@Component({
  selector: 'app-performance-trend-renderer',
  imports: [CommonModule, ArrowIconComponent],
  templateUrl: './performance-trend-renderer.component.html',
  styleUrl: './performance-trend-renderer.component.scss'
})
export class PerformanceTrendRendererComponent implements ICellRendererAngularComp {
  public value: string = '';
  public trend: TrendData = {
    value: 0,
    status: ValueType.NEUTRAL,
    direction: undefined,
    statusColor: 'gray',
    size: 'small',
    display: ''
  };
  public includeScoreBar: boolean = false;
  public valueStyle: { [key: string]: string } = {};
  public trendStyle: { [key: string]: string } = {};
  public containerStyle: { [key: string]: string } = {};

  agInit(params: ICellRendererParams): void {
    this.loadComponent(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.loadComponent(params);
    return true;
  }

  private loadComponent(params: ICellRendererParams): void {
    const cellParams = params.colDef?.cellRendererParams || {};
    const paramsValue = params.value || {};
    const trendConfig = cellParams.trendConfig || {};
    const trend = paramsValue?.trend ?? params.data?.trend ?? 0;
    
    this.value = paramsValue?.value || paramsValue || '';
    this.includeScoreBar = cellParams.includeScoreBar || paramsValue.includeScoreBar || false;
    this.valueStyle = cellParams.valueStyle || paramsValue.valueStyle || {};
    this.trendStyle = cellParams.trendStyle || paramsValue.trendStyle || {};
    this.containerStyle = cellParams.containerStyle || paramsValue.containerStyle || {};

    if (typeof trend === 'number') {
      this.trend.size = trendConfig.size || 'small';
      this.trend.display = `${Math.abs(trend) > 500 ? '>500' : Math.abs(trend) }%`
      this.trend.statusColor = 'gray';
      this.trend.direction = trend > 0 ? 'up' : trend < 0 ? 'down' : undefined;
      this.trend.status = trend > 0 ? ValueType.POSITIVE : 
        trend < 0 ? ValueType.NEGATIVE : ValueType.NEUTRAL;
    }
    else if (typeof trend === 'string') {
      const isNA = trend === ValueType.NA;
      if (isNA) return;

      this.trend.display = trend;
      this.trend.statusColor = 'yellow';
      this.trend.status = trend === ValueType.POSITIVE ? ValueType.POSITIVE :
                          trend === ValueType.NEGATIVE ? ValueType.NEGATIVE :
                          trend === ValueType.NEUTRAL ? ValueType.NEUTRAL :
                          ValueType.NA;
    }
  }
}
